<template>
  <div class="container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Container'
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 370px;
  margin: 0 auto;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
  @extend %clearfix;

  @media (min-width: 768px) {
    max-width: 540px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/chapter/Container.vue